'use client';

import { reconcileClipsV1Api } from '@repo/sdk';
import { Button } from '@repo/ui';
import type { JSX } from 'react';
import { useCallback, useState } from 'react';
import { PipelineStepDialog } from './pipeline-step-dialog';
import { StepLogPanel } from './steps/step-log-panel';
import { useStepAction } from './use-step-action';

export function ReconcileClipsButton(): JSX.Element {
  const [open, setOpen] = useState(false);
  const start = useCallback(() => reconcileClipsV1Api(), []);
  const { status, log, run } = useStepAction({ start });

  return (
    <>
      <Button variant="outline" size="sm" onClick={() => setOpen(true)}>
        Reconcile clips
      </Button>
      <PipelineStepDialog
        open={open}
        onOpenChange={setOpen}
        title="Reconcile clips"
        description="For every collection: fill clips for matchable challenges, then mark the un-recoverable clipless challenges (active, no clip anywhere) as clipless and unlink them from the collection, then enqueue crops. Drives Missing to 0 so Cropped can reach 100 percent. Reversible (a clip later revives the challenge) and safe to re-run."
        primaryAction={{
          label: 'Reconcile all collections',
          onClick: run,
          pending: status === 'running',
        }}
        body={<StepLogPanel status={status} log={log} />}
      />
    </>
  );
}
